import sanitize from "sanitize-html"

const PROSE_HTML_CLASS =
  "text-sm text-muted-foreground [&_a]:text-primary [&_a]:underline [&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-4 [&_ol]:pl-4 [&_p]:mb-2 last:[&_p]:mb-0 [&_strong]:font-semibold"

const BASE_SANITIZE_OPTIONS: sanitize.IOptions = {
  allowedTags: sanitize.defaults.allowedTags.concat([
    "img",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "figure",
    "figcaption",
    "video",
    "source",
  ]),
  allowedAttributes: {
    ...sanitize.defaults.allowedAttributes,
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"],
    a: ["href", "name", "target", "rel"],
    video: ["src", "controls", "width", "height", "poster"],
    source: ["src", "type"],
  },
}

export function sanitizeHtml(html: string): string {
  return sanitize(html, BASE_SANITIZE_OPTIONS)
}

/** Rich article body sanitization (CMS content, optional embeds). */
export function sanitizeArticleHtml(html: string): string {
  return sanitize(html, {
    ...BASE_SANITIZE_OPTIONS,
    allowedTags: [...(BASE_SANITIZE_OPTIONS.allowedTags ?? []), "iframe"],
    allowedAttributes: {
      ...BASE_SANITIZE_OPTIONS.allowedAttributes,
      iframe: [
        "src",
        "allow",
        "allowfullscreen",
        "frameborder",
        "scrolling",
        "width",
        "height",
        "title",
      ],
    },
  })
}

export function stripHtml(html: string): string {
  return sanitize(html, { allowedTags: [], allowedAttributes: {} }).trim()
}

export { PROSE_HTML_CLASS }
